'use client';

import type {FC} from 'react';

import {type ImageWeb} from '@/modules/foundation/components/image/types';
import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import {Gallery} from '@/modules/page/components/content-blocks/gallery';

import type {GallerySchema} from './schema';

interface Props {
	data?: GallerySchema;
}

export const GalleryContainer: FC<Props> = ({data}) => {
	const {layout, images} = data ?? {};

	let aspectRatio = 4 / 3;

	switch (data?.aspectRatio) {
		case '4:3':
			aspectRatio = 4 / 3;
			break;
		case '3:4':
			aspectRatio = 3 / 4;
			break;
	}

	if (!images || images.length === 0) {
		return null;
	}

	const carouselImages: KeyedArray<ImageWeb> = [];

	for (const sanityImage of images) {
		if (!sanityImage.asset?._ref) {
			continue;
		}

		carouselImages.push({
			_key: sanityImage._key,
			...imageWebFromImageWebSchema(sanityImage, aspectRatio),
		});
	}

	if (!carouselImages || carouselImages.length === 0) {
		return null;
	}

	return (
		<Gallery
			spacingBottom={layout?.spacingBottom}
			spacingTop={layout?.spacingTop}
			images={carouselImages}
			width={data?.width}
		/>
	);
};
